import React, {Component} from 'react';
import fire from './fire';
import ThankfulPage from './components/ThankfulPage/ThankfulPage.js';
import HomePage from './components/HomePage/HomePage.js';
import PlaceHolderPage from './components/PlaceHolderPage/PlaceHolderPage.js';
import ReplySavePage from './components/ReplySavePage/ReplySavePage.js';
import DownloadPage from './components/DownloadPage/DownloadPage.js';
import { BrowserRouter as Router, withRouter, Link, Route, Switch } from 'react-router-dom';
import Analytics from 'react-router-ga';
import './App.css';

class App extends Component {

  render() {
    return (
      <Router basename="/?">
        <Analytics id="UA-111469390-1" debug>
          <ScrollToTopWithRouter>
            <Switch>
              <Route exact path="comingsoon" component={PlaceHolderPage}/>
              <Route exact path="reply-save-download" component={ReplySavePage}/>
              <Route exact path="/download" component={DownloadPage}/>
              <Route exact path="download" component={DownloadPage}/>
              <Route path=":thanksId" component={ThankfulPage}/>
              <Route exact path="/" component={HomePage}/>
              <Route component={PlaceHolderPage}/>
            </Switch>
          </ScrollToTopWithRouter>
        </Analytics>
      </Router>
    )
  }
}

export default App;

class ScrollToTop extends Component {
  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      window.scrollTo(0, 0)
    }
  }

  render() {
    return this.props.children
  }
}

const ScrollToTopWithRouter = withRouter(ScrollToTop);


// WEBPACK FOOTER //
// ./src/App.js